<script lang="ts">
  import { Dialog, DialogContent, DialogTitle } from "$lib/components/ui/dialog";
  import { overlay } from "$lib/stores/ui";
  import { t, locale } from "$lib/i18n";

  const isOpen = overlay('manual');
</script>

<Dialog bind:open={$isOpen}>
  <DialogContent
    maxWidth="95vw"
    class="flex h-[92vh] flex-col gap-2 p-4"
    aria-describedby={undefined}
  >
    <DialogTitle>{$t('menu.help')}</DialogTitle>
    <iframe
      src={`/manual/Manual.${$locale}.html`}
      title={$t('menu.help')}
      class="min-h-0 flex-1 rounded border-0 w-full"
    ></iframe>
  </DialogContent>
</Dialog>
